/* eslint-disable */
export default {
    LOG_OUT: 'Logg ut',
    LOGIN: 'Logg inn',
    GET_A_MAP_EXPERT: 'Få en kartekspert',
    MY_ACCOUNT: 'Min konto',
    MY_ACCOUNT_DESC: 'Du kan endre innstillingene dine',
    SUBSCRIPTION: 'Abonnement',
    PASSWORD: 'Passord',
    LANGUAGE: 'Språk',
    AVAILABLE_LANGUAGES: 'Tilgjengelige språk',
    YOU_HAVE_NO_PASSWORD: 'Du har ikke passord',
    YOU_HAVE_NAME: 'Du bruker {0} versjon av Mapheim',
    SUBSCRIBE_ACTION: 'Abonner',
    MANAGE_SUBSCRIPTION: 'Administrer abonnement',
    CANCELLED_SUBSCRIPTION: 'Abonnementet ditt er kansellert og det vil bli deaktivert i slutten av faktureringsperioden',
    RENEW_SUBSCRIPTION: 'Forny abonnement',
    RESUBSCRIBE: 'Abonner på nytt',
    VIEW_PAST_INVOICES: 'Se tidligere fakturaer',
    SUBSCRIBE_NOT_PAID: 'Abonnementet ditt kunne ikke betales. Vennligst sjekk betalingsdetaljene dine og gjenta betalingen',
    REVIEW_PAYMENT: 'Gjennomgå betaling',
    YOUR_MAPS: 'Kartene dine',
    EDIT_CONTENT: 'Rediger innhold',
    ADVANCED_EDITOR: 'Avansert redigering',
    CUSTOM_URL: 'Tilpasset URL',
    UNNAMED_MAP: 'Unavngitt kart',
    EDIT: 'Rediger',
    WELCOME: 'Velkommen',
    WELCOME_DESC: 'Nyt arbeidet med kartene dine!',
    DO_YOU_WANT_NEW_MAP: 'Vil du ha et nytt kart?',
    UPGRADE_ACTION: 'Oppgrader',
    CREATE_ACTION: 'Opprett',
    UPGRADE_EXPERIENCE: 'Oppgrader opplevelsen din',
    UPGRADE_EXPERIENCE_DESC: 'Få mer ut av kartene dine',
    NEED_HELP: 'Trenger du hjelp?',
    LET_US_KNOW: 'La oss få vite',
    CONTACT_ACTION: 'Kontakt',
    MO: 'må.',
    SUB1: 'Skaper',
    SUB1_DESC: 'For entusiastiske skapere',
    VIEWS_PER_MONTH: '{0} visninger / måned',
    MARKERS_PER_MAP: '{0} markører / kart',
    X_MAPS: '{0} kart',
    DEDICATED_SUPPORT: 'Dedikert støtte',
    MANAGE_ACTION: 'Administrer',
    DOWNGRADE_ACTION: 'Nedgrader',
    SUB2: 'Pro',
    SUB2_DESC: 'For profesjonell bruk',
    UNLIMITED_MARKERS: 'Ubegrenset antall markører',
    UNLIMITED_MAPS: 'Ubegrenset antall kart',
    SUB3: 'Tilpasset',
    SUB3_DESC: 'For alle kartbehov',
    SUB3_TEXT1: 'Trenger du flere visninger, spesielle funksjoner eller hjelp med å lage kartet ditt?',
    SUB3_TEXT2: 'Vi har laget kart for fornøyelsesparker, konferanser, turisme, festivaler og mange flere bransjer. La oss få vite',
    CONTACT_US: 'Kontakt oss',
    PREVIEW_MAP: 'Forhåndsvis kart',
    SHARE_ACTION: 'Del',
    GET_ACCESS: 'Få tilgang',
    LOGIN_TO_BECOME: 'Logg inn for å bli en ekte kartskaper eller',
    CREATE_A_MAP: 'lag et kart',
    AS_A_GUEST: 'som gjest',
    REGISTER_CREATOR: 'Registrer deg for å bli en ekte kartskaper',
    REGISTRATION: 'Registrering',
    USING_SOCIALS: 'Bruk av sosiale medier',
    USING_MAIL: 'Bruk av e-post',
    EMAIL_OR_USER: 'E-post eller brukernavn',
    FORGOT_PASSWORD: 'Glemt passord',
    LOGIN_ACTION: 'Logg inn',
    ERROR_USER_NOT_FOUND: 'Brukeren ble ikke funnet',
    ERROR_WRONG_PASSWORD: 'Feil passord',
    ERROR_USER_BANNED: 'Brukeren er utestengt',
    ERROR_EMAIL_NOT_VERIFIED: 'E-posten er ikke verifisert',
    ERROR_LOGIN: 'Feil ved innlogging',
    VERIFICATION_SENT1: 'Verifiseringslenken ble sendt til e-postadressen din',
    VERIFICATION_SENT2: 'Sjekk innboksen og søppelposten din og klikk på lenken for å fullføre registreringen',
    EMAIL: 'E-post',
    CONFIRM_PASSWORD: 'Bekreft passord',
    INVALID_EMAIL: 'E-posten er ugyldig',
    PASSWORD_NOT_STRONG: 'Det nye passordet er ikke sterkt nok eller passordene er ikke like. Det må være minst 6 tegn langt',
    EMAIL_USED: 'Brukeren med denne e-posten er allerede registrert',
    ERROR_REGISTRATION: 'Feil ved registrering av ny bruker',
    MAP_NOT_ACCESSIBLE: 'Denne kartet kan ikke åpnes',
    MAP_NOT_ACCESSIBLE_DESC: 'Vennligst kontakt eieren av kartet for å gjøre kartet tilgjengelig igjen',
    RETRIEVE_ACCESS: 'Få tilgang',
    RETRIEVE_ACCESS_DESC: 'Endre passordet ditt for å bli en ekte kartskaper',
    SEND_RESET_LINK_ACTION: 'Send lenken',
    RESET_LINK_SENT: 'En e-post med en tilbakestillingslenke ble sendt til e-postadressen din. Sjekk innboksen og søppelposten din',
    ERROR_SENT_LINK: 'Feil ved sending av tilbakestillingslenken',
    EMAIL_VERIFIED: 'E-post verifisert',
    EMAIL_VERIFIED_DESC: 'Logg inn og begynn å lage',
    RESET_PASSWORD: 'Tilbakestill passord',
    RESET_PASSWORD_DESC: 'Endre passordet ditt for å bli en ekte kartskaper',
    INVALID_LINK: 'Ugyldig lenke',
    ERROR_RESET_CODE: 'Tilbakestillingskoden utløp. Send en ny tilbakestillingskode',
    ERROR_RESETTING: 'Feil ved oppsett av nytt passord',
    NEW_PASSWORD: 'Nytt passord',
    SET_NEW_PASSWORD: 'Sett nytt passord',
    HEADER: 'Overskrift',
    NO_HEADER: 'Ingen overskrift',
    TITLE: 'Tittel',
    DESCRIPTION: 'Beskrivelse',
    SELECT_ACTION: 'Velg',
    CONTENT: 'Innhold',
    CONTENT_DESC: 'Du kan også legge til en rekke innholdskort til markøren din (anbefalt)',
    POST_URL: 'Post-URL',
    POST_ID: 'Post-ID',
    VIDEO_URL: 'Video-URL',
    ADD_FIRST_CARD: 'Legg til et første kort',
    LINK: 'Lenke',
    CONFIRM_DELETE_LINK: 'Vil du slette denne lenken?',
    ADD_LINK: 'Legg til lenke',
    ADD_ANOTHER_LINK: 'Legg til en annen lenke',
    NAME: 'Navn',
    TYPE: 'Type',
    GUIDE: 'Guide',
    OLD_GUIDE: 'Gammel guide',
    SHARE_THE_LINK: 'Del lenken',
    COPY_MAP_ID: 'Kart-ID for Wordpress Plugin',
    COPY_MAP_ID_ACTION: 'Kopier kart-ID',
    COPY_MAP_ID_CLIPBOARD: 'Kart-ID kopiert til utklippstavle',
    LINK_COPIED_CLIPBOARD: 'Lenke kopiert til utklippstavle',
    GUIDE_COLORS_ACCENT1: 'Hovedfarge',
    CUSTOM: 'Tilpasset',
    SAVE: 'Lagre',
    ALL_SAVED: 'Alt lagret',
    COPY_URL_ACTION: 'Kopier URL',
    GENERATE_QR_CODE: 'Generer QR-kode',
    DOWNLOAD_QR_ACTION: 'Last ned QR',
    EMBED_ON_YOUR_SITE: 'Bygg inn på din side',
    COPY_HTML_ACTION: 'Kopier HTML',
    HTML_COPIED_CLIPBOARD: 'HTML kopiert til utklippstavle',
    HISTORY: 'Historikk',
    MARKERS: 'Markører',
    LOCATION: 'Sted',
    LOADING: 'Laster inn',
    NOTHING_FOUND: 'Ingenting funnet',
    PLEASE_WRITE_CHARACTERS: 'Vennligst skriv minst 3 tegn',
    MOUSE: 'Mus',
    PIN: 'Pin',
    IMAGE: 'Bilde',
    TEXT: 'Tekst',
    DRAW: 'Tegn',
    DIRECTION: 'Retning',
    LINE: 'Linje',
    POLYGON: 'Polygon',
    WALL_LINE: '3D Vegg',
    WALL_FILL: '3D Vegg (Fylt)',
    REACT: 'React',
    CHATGPT: 'ChatGPT',
    UPLOAD_ACTION: 'Last opp',
    PROPERTIES: 'Egenskaper',
    INTERACTIVITY: 'Interaktivitet',
    MAP_SETTINGS: 'Kartinnstillinger',
    PRIVACY: 'Personvern',
    PRIVACY_DESC: 'Private kart kan ikke deles med noen',
    GPS_POSITION: 'GPS-posisjon',
    ENABLED: 'Aktivert',
    DISABLED: 'Deaktivert',
    BUBBLE_DESC: 'Klikk på interaktiv markør for å vise en liten boble. Anbefales for et minimum av innhold',
    MINI_DESC: 'Klikk på interaktiv markør for å vise et popup-vindu. Anbefales for en liten mengde innhold',
    STYLE1_DESC: 'Klikk på interaktiv markør for å vise en sidepanel. Anbefales for hvilken som helst mengde innhold',
    PANEL: 'Panel',
    POPUP: 'Popup',
    BUBBLE: 'Boble',
    PUBLIC: 'Offentlig',
    PRIVATE: 'Privat',
    MAP_STYLE: 'Kartstil',
    FILL_COUNTRIES: 'Fyll land',
    REGISTER_PROMPT: 'Registrer deg for å lagre fremdriften din',
    GET_MORE_PROMPT: 'Få flere besøk og ubegrenset antall markører ved å oppgradere til Pro-modus',
    CONTACT_PROMPT: 'Vil du ha tidlig tilgang til avansert redigering, eller trenger du enda flere visninger?',
    UNLOCK_PROMPT: 'Lås opp alle funksjonene og øk antall kartbesøk med Creator- eller Pro-modus',
    UPGRADE: 'Oppgrader',
    MAP_VISITS_LIMIT: 'Begrensning av kartbesøk',
    MARKER_LIMIT: 'Begrensning av markører',
    ADVANCED_EDITOR_ACCESS: 'Tilgang til avansert redigering',
    REGISTER_ACTION: 'Registrer',
    NO: 'Nei',
    YES: 'Ja',
    SYMBOL: 'Symbol',
    YOUR_IMAGE: 'Ditt bilde',
    SEARCH: 'Søk',
    SEARCH_ON_MAP: 'Søk på kart',
    MORE: 'Mer',
    BACKGROUND: 'Bakgrunn',
    CONTROLS: 'Kontroller',
    CLONE: 'Klon',
    ORDER: 'Rekkefølge',
    TOP: 'Topp',
    BOTTOM: 'Ned',
    EMOJI: 'Emoji',
    SEARCH_GIFS: 'Søk i GIF-er',
    DELETE: 'Slett',
    TRANSPORTATION: 'Transport',
    COORDINATES: 'Koordinater',
    POINT_X: 'Punkt {0}',
    POSITION: 'Posisjon',
    GROUND_COLOR: 'Gulv',
    STYLE: 'Stil',
    COLOR: 'Farge',
    SIZE: 'Størrelse',
    POSITION_DESC: 'Klikk hvor som helst på kartet for å endre posisjonen',
    TRANSFORM: 'Transformere',
    ROTATE: 'Roter',
    SCALE: 'Skala',
    BORDER_SIZE: 'Rammestørrelse',
    OPACITY: 'Gjennomsiktighet',
    BORDER_COLOR: 'Ramme farge',
    DASHED: 'Stiplet',
    HEIGHT: 'Høyde',
    BASE_HEIGHT: 'Basehøyde',
    WIDTH: 'Bredde',
    DIRECTION_ADD1: 'Klikk hvor som helst på kartet for å angi et startpunkt eller søk etter en adresse',
    DIRECTION_ADD2: 'Klikk igjen for å angi destinasjonen eller søk etter en adresse (eller Esc for å avbryte)',
    ICON_ADD: 'Klikk hvor som helst på kartet eller søk etter en adresse for å legge til en Pin. Pinnen holder alltid samme størrelse',
    VARIANT_ICON_ADD: 'Klikk hvor som helst på kartet eller søk etter en adresse for å legge til en Pin. Pinnen holder, men stilen endres basert på zoomnivået',
    IMAGE_ADD: 'Klikk hvor som helst på kartet for å laste opp et bilde, eller dra og slipp et av symbolene eller bildene fra galleriet',
    TEXT_ADD: 'Klikk hvor som helst på kartet for å legge til en tekst',
    LINE_ADD: 'Begynn å klikke på kartet for å tegne en linje. Trykk Enter for å fullføre (eller Esc for å avbryte)',
    POLYGON_ADD: 'Begynn å klikke på kartet for å tegne en polygon. Trykk Enter for å fullføre (eller Esc for å avbryte)',
    WALL_ADD: 'Begynn å klikke på kartet for å tegne en 3D-vegg. Trykk Enter for å fullføre (eller Esc for å avbryte)',
    ADDRESS_SEARCH: 'Adresse søk',
    STARTING_POINT: 'Startpunkt',
    DESTINATION: 'Destinasjon',
    GALLERY: 'Galleri',
    POLYGON_ADD2: 'Polygoner kan gjøres usynlige og fortsatt utløse klikkhandlinger (Fordelaktig spesielt for bildekart)',
    ZOOM_IN_MORE: 'Zoom inn mer for å tegne en vegg',
    LABEL: 'Etikett',
    ICON: 'Ikon',
    INTERACTIVITY_PROMPT: 'Definer hva folk ser når de klikker på markøren',
    CREATE_INTERACTIVITY_ACTION: 'Opprett interaktivitet',
    CONFIRM_SAVE: 'Vil du lagre endringene dine?',
    CONFIRM_REMOVE_INTERACTIVITY: 'Vil du fjerne denne interaktiviteten?',
    SAVING: 'Lagrer',
    REFRESH_PREVIEW: 'Oppdater forhåndsvisning',
    SHOW_PREVIEW: 'Vis forhåndsvisning',
    REMOVE_INTERACTIVITY: 'Fjern interaktivitet',
    MAX_LENGTH_TEXT_MARKER: 'Du har nådd maksimal tekstlengde på 1000 tegn',
    MAP_ROTATION: 'Kartrotasjon',
    PITCH_ANGLE: 'Pitch-vinkel (visning bare)',
    GPX_FILE: 'GPX-fil',
    GPX_UPLOAD_MESSAGE: 'Last opp GPX-filen din til høyre. Hvis filen ikke støttes, skriv oss en melding',
    EXPERIMENTAL_FEATURES_MESSAGE: 'Du kan aktivere eksperimentelle funksjoner. Dette er kun ment for erfarne skapere og testere',
    EXPERIMENTAL: 'Eksperimentell',
    LATITUDE: 'Breddegrad',
    LONGITUDE: 'Lengdegrad',
    FILE_UPLOAD: 'Filopplasting',
    UNKNOWN_GPX_FILE: 'Ukjent GPX-filformat',
    OPEN_GALLERY: 'Åpne galleri',
    GALLERY_ALL: 'Alle',
    GALLERY_YOUR_IMAGES: 'Dine bilder',
    GALLERY_CATEGORY_IMAGES: 'Kategori bilder',
    GALLERY_NATURE: 'Natur',
    GALLERY_ANIMALS: 'Dyr',
    GALLERY_VEHICLES: 'Kjøretøy',
    GALLERY_BUILDINGS: 'Bygninger',
    GALLERY_FLAGS: 'Flagg',
    USE_COMPUTER: 'Bruk en datamaskin for å lage kart',
    USE_COMPUTER_DESC: 'Kartredigeringsprogrammet er ikke optimalisert for mobile enheter, bruk en større skjerm. Ikke bekymre deg, alle kartene som er opprettet gjennom redigeringsprogrammet, fungerer bra på mobile enheter.',
    CONTINUE_ANYWAY: 'Fortsett likevel',
    GO_TO_HOMEPAGE: 'Gå til hjemmesiden',
    DELETE_MAP: 'Slett kart',
    ADD_FLOOR: 'Legg til etasje',
    FLOORS: 'Etasjer',
    FLOOR_NR: 'Etasje nr.',
    ADD_CATEGORY: 'Legg til kategori',
    CATEGORIES: 'Kategorier',
    CATEGORY_NR: 'Kategori nr.',
    VISIBLE_ON_LOAD: 'Synlig ved lasting',
    DELETE_MAP_CONFIRM: 'Vil du virkelig slette dette kartet?',
    DELETE_FLOOR_CONFIRM: 'Vil du virkelig slette dette gulvet?',
    DELETE_CATEGORY_CONFIRM: 'Vil du virkelig slette denne kategorien?',
    STAND: 'Stå',
    CLICK_ANYWHERE_TO_STAND: 'Klikk hvor som helst for å legge til en stand',
    MAP_DELETED: 'Kart slettet',
    PIN_IMAGE: 'Pin-bilde',
    LOGO_IMAGE: 'Logo-bilde',
    FILLING: 'Fylling',
    FILLING1: 'Denne innstillingen viser bare 3D-veggen. Det siste punktet trenger ikke å være koblet til det første',
    FILLING2: 'Denne innstillingen viser 3D-vegg og gulv. Det lukker automatisk området',
    FILLING3: 'Denne innstillingen oppretter en 3D-struktur. Det lukker automatisk området',
    BOOKING: 'Booking',
    DELETE_BOOKING: 'Slett booking',
    DELETE_BOOKING_CONFIRM: 'Er du sikker på at du vil slette denne bookingen? Denne handlingen kan ikke angres.',
    BOOKING_FIELD_TYPE_CHECKBOX: 'Ja/Nei',
    BOOKING_FIELD_TYPE_TEXT: 'Tekst',
    BOOKING_FIELD_TYPE_EMAIL: 'E-post',
    BOOKING_EMPTY_INFO: 'Ingen booking eksisterer ennå. Nedenfor kan du se feltene som samles inn.',
    FIELD_REQUIRED: 'Dette feltet er påkrevd',
    BOOKING_SUBMIT: 'Opprett booking',
    BOOKING_SUCCESS_TITLE: 'Booking bekreftet',
    BOOKING_SUCCESS_MESSAGE: 'Takk for bookingen din. Du vil motta en bekreftelses-e-post til innboksen din. Hvis du ikke ser e-posten i innboksen din, vennligst sjekk søppelposten din',
    BOOKING_SUCCESS_MESSAGE_CHECK_SPAM: 'vennligst sjekk søppelposten din.',
    BOOKING_FAILED_TITLE: 'Booking kunne ikke opprettes',
    BOOKING_FAILED_MESSAGE: 'Det ser ut til at noen booket denne standen før deg. Vennligst oppdater siden og velg en stand fra kartet som er ledig for booking. De ledige standene er merket i grønt.',
    BOOKING_FULL_TITLE: 'Denne standen er allerede booket',
    BOOKING_FULL_MESSAGE: 'Vennligst velg en stand fra kartet som er ledig for booking. De ledige standene er merket i grønt.',
    BOOKING_CLOSE_DIALOG: 'Lukk dialog',
    BOOKING_SEE_OTHER_STANDS: 'Se kartet',
    OR: 'eller',
    SEARCH_DETAIL_PLACEHOLDER: 'Søk eksisterende interaktivitet',
    REFRESH_PAGE: 'Oppdater siden',
    EXTERNAL_LINK: 'Ekstern lenke',
    STAND_MARKER1: 'Ikon (Zoomet inn)',
    STAND_MARKER2: 'Ikon (Zoomet ut)',
    LOAD_FROM_DETAIL: 'Last inn fra detalj',
    DISPLAY_IN_RECTANGLE: 'Vis i rektangel',
    COLORED_PIN: 'Farget pin',
    CUSTOM_IMAGE: 'Egendefinert bilde',
    USE_IN_GUIDE: 'Bruk i guide',
    LOCATION_NAME: 'Stedsnavn',
    DETAILS: 'Detaljer',
    PREVIEW: 'Forhåndsvisning',
    UNSAVED_CHANGES: 'Ulagrede endringer',
    NO_TITLE: 'Ingen tittel',
    SHOW_ON_ZOOM: 'Zoom (Vis på kart)',
    NO_EDIT_IN_MAP_EDITOR: 'Denne innholdet kan ikke redigeres i Map Editor.',
    GLOBAL_POINTS_EDIT_NOT_SUPPORTED: 'Globale punkter kan ikke redigeres. Rediger dette punktet direkte i CMS-systemet ditt',
    NEWSFEED: 'Nyhetsfeed',
    EDIT_NEWSFEED_MESSAGE: 'Rediger nyhetsfeed-melding',
    PC_WELCOME_MESSAGE: 'PC Velkomstmelding',
    TEST_NEWSFEED_NOTIFICATION: 'Test nyhetsfeed-varsel',
    NEWSFEED_SELECT_USERS: 'Velg brukere',
    NEWSFEED_SEND_TEST_NOTIFICATION: 'Send testvarsel',
    HEADER_IMAGE: 'Overskriftsbilde',
    NAVIGATION_TITLE: 'Navigasjon',
    NAVIGATION_DESCRIPTION: 'Definer hvordan brukeren navigerer i applikasjonen din',
    NAVIGATION_LINK_DESTINATION: 'Lenkemål',
    NAVIGATION_EXTERNL_URL: 'Ekstern URL',
    NAVIGATION_SELECT_LIST: 'Velg liste',
    NAVIGATION_SELECT_FORM: 'Velg skjema',
    NAVIGATION_SHOW_DYNAMIC_NUMBER: 'Vis dynamisk nummer',
    NAVIGATION_CUSTOM_ICON: 'Egendefinert ikon',
    NAVIGATION_CUSTOM_TITLE: 'Egendefinert tittel',
    NAVIGATION_DRAWER_HELP: 'Skuffen er delt inn i primære (store) og sekundære (små) knapper. Du kan sette opp hvor mange av knappene som er primære',
    NEWSFEED_CREATE_NEW_MESSAGE: 'Opprett ny melding',
    NEWSFEED_HELP: 'Oppdateringer som du kan dele med besøkende. Meldinger er synlige i nyhetsfeed-seksjonen, og brukere blir informert om dem via Push-varsler',
    NEWSFEED_REMOVE_CONFIRM: 'Er du sikker på at du vil fjerne nyhetsfeed-meldingen?',
    NEWSFEED_SEND_TO_ALL_CONFIRM: 'Er du sikker på at du vil sende varsel til alle app-brukere?',
    NEWSFEED_NOTIFICATIONS: 'Varsler',
    NEWSFEED_NOTIFICATIONS_SENT: 'Varsler sendt',
    ROOMS: 'Rom',
    VARIANT_ICON: 'Variant ikon',
    LIST_VIEW_TYPE: 'Listevisningstype',
    CREATE_FORM: 'Opprett skjema',
    EDIT_FORM: 'Rediger skjema',
    FORM_TITLE: 'Skjematittel',
    FORM_THANK_YOU_MESSAGE: 'Takk melding',
    FORM_ALLOW_MULTIPLE_SUBMISSIONS: 'Tillat flere innsendinger',
    FORM: 'Skjema',
    FORM_FIELDS: 'Felter',
    FORM_FIELD_TITLE: 'Felttittel',
    FORM_FIELD_TEXT: 'Tekstfelt',
    FORM_OPTIONS: 'Alternativer',
    REQUIRED: 'Påkrevd',
    EXTERNAL_POINTS: 'Eksterne punkter',
    EXTERNAL_POINTS_DESCRIPTION: 'Legg til eksterne punkter fra CMS-en din',
    ENABLE_HIGHLIGHTED_CATEGORY: 'Aktiver fremhevet kategori',
    TOP_LEFT: 'Øverst til venstre',
    BOTTOM_RIGHT: 'Nederst til høyre',
    INITIAL_POSITION: 'Startposisjon',
    ZOOM_SETTINGS: 'Zoominnstillinger',
    VISIBLE_IN: 'Synlig i',
    MAP_ORIENTATION: 'Kartorientering',
    MIN_MAX_ZOOM: 'Min/Maks zoom',
    CURRENT_VIEW_INFO: 'Gjeldende visningsinfo',
    CURRENT_ZOOM: 'Gjeldende zoom',
    LAST_CLICK: 'Siste klikk',
    GLOBAL_MARKER_SETTINGS: 'Globalt markørinnstillinger',
    PIN_SETTINGS: 'Pin-innstillinger',
    TEXT_COLOR: 'Tekstfarge',
    BACKGROUND_COLOR: 'Bakgrunnsfarge',
    AUTO_HIDE_LABELS: 'Auto skjul etiketter',
    MARKER_GROUPING: 'Markørgruppering',
    MAX_CLUSTERING_ZOOM: 'Maksimal klynging zoom',
    CLUSTER_RADIUS: 'Klynge radius',
    SHOW_LIST_OF_DETAILS: 'Vis liste over detaljer',
    NO_LIST: 'Ingen liste',
    SHOW_LIST: 'Vis liste',
    SHOW_LIST_WITH_SEARCH: 'Vis liste med søk',
    HOME: 'Hjem',
    MAP: 'Kart',
    PROGRAMME_SHORT: 'Program',
    SPEAKERS: 'Foredragsholdere',
    INFO: 'Info',
    MAP_VIEW: 'Kartvisning',
    REMOVE_FILTERS: 'Fjern filtre',
    LIST_VIEW: 'Listvisning',
    GUIDANCE: 'Guidning',
    HIGHLIGHTED: 'Fremhævet',
    EXHIBITORS: 'Utstillere',
    SURVEY: 'Spørgeskema',
    OPEN_ON_YOUR_PHONE: 'Åpne på din telefon',
    INTERACTIVE_MAP: 'Interaktivt kart',
    SHOW_MORE: 'Vis mer',
    LINKS: 'Links',
    FORM_SUBMIT: 'Send skjema',
    FORM_SUBMITTED: 'Skjemaet er sendt',
    INVALID_VALUE: 'Ugyldig verdi',
    COMPANIES: 'Bedrifter',
    LIST: 'Liste',
    FILTERS: 'Filtre',
    ZOOM: 'Zoom',
    HIGHLIGHT: 'Fremhev',
    UNHIGHLIGHT: 'Avbryt',
    WEBSITE: 'Nettside',
    PREVIOUS: 'Forrige',
    NEXT: 'Neste',
    SHOW_ON_MAP: 'Vis på kart',
    CLOSE: 'Lukk',
    SHOW_ALL: 'Vis alle',
    HIDE_ALL: 'Skjul alle',
    PROGRAMME: 'Program',
    PLACES: 'Steder',
    THIS_IS_INTERACTIVE_MAP: 'Dette er et interaktivt kart',
    CLICK_ON_INFO: 'Klikk på markørene for mer informasjon',
    CONTINUE: 'Fortsett',
    MAPBOX_SCROLL_ZOOM_BLOCKER_CTRL: 'Bruk ctrl + scroll for å zoome kartet',
    MAPBOX_SCROLL_ZOOM_BLOCKER_COMMAND: 'Bruk ⌘ + scroll for å zoome kartet',
    SUBMIT_AGAIN: 'Send igjen',
    OTHER_ITEMS: 'Andre',
    MAIN_H1: 'Opprett et interaktivt kart på et minutt',
    MAIN_H2: 'Del det, Embed det, Selg det. Som du vil. Ingen registrering nødvendig',
    YOUR_POSSIBILITIES: 'Dine muligheter',
    GET_YOUR_INSPIRATION: 'Få inspirasjon',
    NAME_YOUR_MAP: 'Navngi kartet ditt',
    AGREE_WITH: 'Jeg er enig med',
    TERMS_AND_CONDITIONS: 'vilkårene',
    CREATE_YOUR_MAP: 'Lag kartet ditt',
    HERO_BLOCK1_H1: 'Velg din stil',
    HERO_BLOCK1_P1: 'Velg en kartstil du liker. Du kan velge mellom mange forskjellige stiler som passer dine behov og ditt varemerke. Du kan til og med laste opp ditt eget kart som et bilde og legge til interaktive markører',
    HERO_BLOCK2_H1: 'Legg til markører',
    HERO_BLOCK2_P1: 'Vis frem din kreative side. Du kan legge til markører som pinner, bilder, figurer, stier og linjer på kartet. Du kan også velge fra et bibliotek med AI-genererte bilder og ikoner som er klare til bruk',
    HERO_BLOCK3_H1: 'Gjør det interaktivt',
    HERO_BLOCK3_P1: 'Hver markør du plasserer på kartet, kan gjøres interaktiv. Når de besøkende klikker på den, kan de se tekst, bilder, lenker, videoer og mye mer. På denne måten kan du enkelt gi dem ekstra verdi',
    TRAVELLING: 'Reiser',
    CABIN_MAP: 'Hyttekart',
    CITY_MAP: 'Bykart',
    FOOD_FESTIVAL: 'Matfestival',
    FESTIVALS: 'Festivaler',
    MUSIC_FESTIVAL: 'Musikkfestival',
    FAIRS: 'Messer',
    JOB_FAIR: 'Jobbmesse',
    THEME_PARKS: 'Tema parker',
    FAMILY_PARK: 'Familiepark',
    CONFERENCES: 'Konferanser',
    CONFERENCE: 'Konferanse',
    BUSINESS: 'Forretninger',
    CUSTOMER_MAP: 'Kundekart',
    SPORT: 'Sport',
    RUNNING_RACE: 'Løp',
    TRONDHEIM_NORWAY: 'Trondheim, Norge',
    GOTA_FAROE_ISLANDS: 'Gota, Færøyene',
    TYDAL_NORWAY: 'Tydal, Norge',
    LIBEREC_CZECHIA: 'Liberec, Tsjekkia',
    AGDER_NORWAY: 'Agder, Norge',
    AARHUS_DENMARK: 'Aarhus, Danmark',
    NAMSSKOGAN_NORWAY: 'Namsskogan, Norge',
    HEMSEDAL_NORWAY: 'Hemsedal, Norge',
    BRNO_CZECHIA: 'Brno, Tsjekkia',
    CHOOSE_YOUR_STYLE: 'Velg din stil',
    CLASSIC: 'Klassisk',
    SATELLITE: 'Satellitt',
    OUTDOORS: 'Utendørs',
    DARK: 'Mørk',
    LIGHT: 'Lys',
    COLORED: 'Farget',
    IMAGE_MAP: 'Bildekart',
    UPLOADING: 'Laster opp',
    BACK: 'Tilbake',
    I_LIKE_THIS_ONE: 'Jeg liker denne',
    CONGRAT_TITLE: 'Gratulerer, kartet ditt er opprettet!',
    CONGRAT_DESC: 'Legg nå til noen markører for å fremheve stedene dine',
    MARKER_SELECTION: 'Markeringsvalg',
    MARKER_SELECTION_DESC: 'Velg markører fra bunnen',
    STYLING: 'Styling',
    STYLING_DESC: 'Styl markører til høyre',
    START_ACTION: 'Begynn å legge til markører',
    CREATING_PROMPT1: 'Hei!',
    CREATING_PROMPT1_DESC: 'Du lager et flott kart! Ikke mist fremgangen din når du forlater siden. Få en konto nå gratis',
    CREATING_PROMPT2: 'Vil du ha flere funksjoner?',
    CREATING_PROMPT2_DESC: 'Bli med på ventelisten vår og vær blant de første til å få flere kartfunksjoner!',
    JOIN_ACTION: 'Bli med',
    ALREADY_CREATING: 'Du lager allerede kart',
    CONTINUE_CREATING: 'Fortsett å lage',
    ALL: 'Alt',
    EAT: 'Spis',
    EXPLORE: 'Utforsk',
    EXPERIENCE: 'Opplev',
    LEARN: 'Lære',
    LANDING_TITLE: 'undefined',
    LANDING_DESCRIPTION: 'undefined',
    LANDING_ITEM1: 'undefined',
    LANDING_ITEM2: 'undefined',
    LANDING_ITEM3: 'undefined',
    GUIDES: 'undefined',
    GUIDES_DESC: 'undefined',
    EDIT_GUIDE_NO_LOGIN: 'undefined',
    CREATE_GUIDE_NO_LOGIN: 'undefined',
    NEW_GUIDE_TITLE: 'undefined',
    NEW_MAP_TITLE: 'undefined',
    NEW_GUIDE_MESSAGE: 'undefined',
    INTERACTIVE_MAPS: 'undefined',
    INTERACTIVE_MAPS_DESC: 'undefined',
    EDIT_MAP_NO_LOGIN: 'undefined',
    CREATE_MAP_NO_LOGIN: 'undefined',
    CREATE_GUIDE: 'undefined',
    GUIDE_NAME: 'undefined',
    ACTIONS: 'undefined',
    MAP_NAME: 'undefined',
    EDIT_MAP: 'undefined',
    EDIT_DETAILS: 'undefined',
    CREATE_MAP: 'undefined',
    CONFIGURATION: 'undefined',
    LISTS: 'undefined',
    PROGRAM: 'Program',
    SHARE: 'undefined',
    CONFIGURATION_TITLE: 'undefined',
    CONFIGURATION_DESC: 'undefined',
    CONFIGURATION_ITEM1: 'undefined',
    CONFIGURATION_ITEM2: 'undefined',
    CONFIGURATION_ITEM3: 'undefined',
    CONFIGURATION_ITEM4: 'undefined',
    BASIC_INFORMATION: 'undefined',
    BASIC_INFORMATION_DESC: 'undefined',
    FEATURES: 'undefined',
    FEATURES_DESC: 'undefined',
    OTHER_INFORMATION: 'undefined',
    EXTERNAL_LINKS: 'undefined',
    EXTERNAL_LINKS_DESC: 'undefined',
    CUSTOM_FEATURES: 'undefined',
    CUSTOM_FEATURES_DESC: 'undefined',
    CUSTOM_FEATURES_ITEM1: 'undefined',
    CUSTOM_FEATURES_ITEM2: 'undefined',
    CUSTOM_FEATURES_ITEM3: 'undefined',
    INFORMATION: 'undefined',
    WELCOME_MESSAGE: 'undefined',
    COLOR_THEME: 'undefined',
    LOGO: 'undefined',
    LISTS_DESC2: 'undefined',
    PROGRAM_DESC: 'undefined',
    INFO_DESC: 'undefined',
    MAP_DESC: 'undefined',
    OPEN_ACTION: 'undefined',
    START_DATE: 'undefined',
    END_DATE: 'undefined',
    MAP_PREVIEW: 'undefined',
    DATES: 'undefined',
    VISUAL: 'undefined',
    ASK_REMOVE_LINK: 'undefined',
    URL: 'undefined',
    MESSAGE: 'undefined',
    SEND_EMAIL: 'undefined',
    EMAIL_SENT1: 'undefined',
    EMAIL_SENT2: 'undefined',
    EMAIL_SENT1_DESC: 'undefined',
    EMAIL_SENT2_DESC: 'undefined',
    CLONE_GUIDE: 'undefined',
    CLONING: 'undefined',
    CLONE_MESSAGE: 'undefined',
    DELETE_GUIDE: 'undefined',
    DELETING: 'undefined',
    DELETE_MESSAGE: 'undefined',
    CANCEL: 'undefined',
    CONFIRM: 'undefined',
    NEW_DETAIL: 'undefined',
    DETAIL_CREATED: 'undefined',
    CATEGORY_CREATED: 'undefined',
    DONE: 'undefined',
    DETAILS_TITLE: 'undefined',
    DETAILS_DESC: 'undefined',
    DETAILS_ITEM1: 'undefined',
    DETAILS_ITEM2: 'undefined',
    DETAILS_DESC2: 'undefined',
    CREATING: 'undefined',
    CREATE_DETAIL: 'undefined',
    NOT_USED: 'undefined',
    FILTER: 'undefined',
    CREATE_CATEGORY: 'undefined',
    CATEGORIES_DESC: 'undefined',
    ASK_DELETE_DETAIL: 'undefined',
    USAGE: 'undefined',
    ASK_DELETE_CATEGORY: 'undefined',
    QUICK_ASSIGN_LISTS: 'undefined',
    EDIT_CATEGORIES: 'undefined',
    NO_CATEGORIES: 'undefined',
    GO_TO_DETAILS: 'undefined',
    EDIT_CATEGORY: 'undefined',
    BACK_TO_DETAILS: 'undefined',
    EDIT_DETAIL: 'undefined',
    EDIT_DETAIL_DESC: 'undefined',
    EDIT_DETAIL_ITEM1: 'undefined',
    EDIT_DETAIL_ITEM2: 'undefined',
    EDIT_DETAIL_ITEM3: 'undefined',
    EDIT_DETAIL_ITEM4: 'undefined',
    HEADER_DETAIL: 'undefined',
    HEADER_DETAIL_DESC: 'undefined',
    CONTENT_DETAIL: 'undefined',
    CONTENT_DETAIL_DESC: 'undefined',
    LIVE_PREVIEW: 'undefined',
    STRETCH_IMAGE: 'undefined',
    GIF_CARD: 'undefined',
    ASK_DELETE_IMAGE: 'undefined',
    IMAGE_CARD: 'undefined',
    LINK_CARD: 'undefined',
    LINKED_STORIES_CARD: 'undefined',
    TEXT_CARD: 'undefined',
    ASK_DELETE_CARD: 'undefined',
    OPEN_YOUTUBE: 'Åpne YouTube',
    OPEN_FACEBOOK: 'Åpne Facebook',
    OPEN_TWITTER: 'Åpne Twitter',
    OPEN_INSTAGRAM: 'Åpne Instagram',
    CREATE_LISTS_TITLE: 'undefined',
    CREATE_LISTS_DESC: 'undefined',
    CREATE_LISTS_ITEM1: 'undefined',
    CREATE_LISTS_ITEM2: 'undefined',
    CREATE_LISTS_ITEM3: 'undefined',
    LISTS_DESC: 'undefined',
    CREATE_LIST: 'undefined',
    THIS_PREVIEW: 'undefined',
    THIS_PREVIEW_DESC: 'undefined',
    OPEN_IN_TAB: 'undefined',
    ASK_DELETE_LIST: 'undefined',
    LINKED_DETAILS: 'undefined',
    LINK_DETAILS: 'undefined',
    NO_DETAILS: 'undefined',
    SEARCH_DETAILS: 'undefined',
    NO_OPTIONS: 'undefined',
    EDIT_LIST: 'undefined',
    LINK_TEXT: 'undefined',
    LINK_URL: 'undefined',
    LINK_TO_MAP: 'undefined',
    SEARCHABLE: 'undefined',
    MODIFY_PROGRAM: 'undefined',
    MODIFY_PROGRAM_DESC: 'undefined',
    MODIFY_PROGRAM_ITEM1: 'undefined',
    MODIFY_PROGRAM_ITEM2: 'undefined',
    MODIFY_PROGRAM_ITEM3: 'undefined',
    EVENTS: 'undefined',
    EVENTS_DESC: 'undefined',
    CREATE_EVENT: 'undefined',
    ASK_REMOVE_EVENT: 'undefined',
    IN_MAP: 'undefined',
    DATE: 'undefined',
    EDIT_EVENT: 'undefined',
    AUTOFILL_INFO: 'undefined',
    TIME_START: 'undefined',
    TIME_END: 'undefined',
    MAP_LOCATION: 'undefined',
    SELECT_MARKER: 'undefined',
    NO_MAP_LOCATIONS: 'undefined',
    GO_TO_MAP: 'undefined',
    MODIFY_INFORMATION: 'undefined',
    MODIFY_INFORMATION_DESC: 'undefined',
    MODIFY_INFORMATION_ITEM1: 'undefined',
    INFORMATION_DESC: 'undefined',
    CREATE_MAP_TITLE: 'undefined',
    CREATE_MAP_DESC: 'undefined',
    CREATE_MAP_ITEM1: 'undefined',
    INTERACTIVE_MAP_DESC: 'undefined',
    OPEN_EDITOR: 'undefined',
    SHARE_APPLICATION: 'undefined',
    SHARE_APPLICATION_DESC: 'undefined',
    SHARE_APPLICATION_ITEM1: 'undefined',
    SHARE_APPLICATION_ITEM2: 'undefined',
    SHARE_THE_APPLICATION: 'undefined',
    SHARE_THE_APPLICATION_DESC: 'undefined',
    COPY_LINK: 'undefined',
    COPY: 'undefined',
    OPEN_LINK: 'undefined',
    DOWNLOAD_QR: 'undefined',
    QR_CODE: 'undefined',
    EMBEDDED_MAP_IFRAME: 'undefined',
    FORMS: 'undefined',
    FORM_SUBMISSIONS: 'undefined',
    FORMS_DESC: 'undefined',
    MAP_V2_SEARCH_THIS_MAP: 'Søk på kartet',
    MAP_V2_COLLAPSE: 'Skjul',
    MAP_V2_EXPAND: 'Vis',
    MAP_V2_GO_BACK: 'Gå tilbake',
    MAP_V2_GOOGLE_MAPS_NAVIGATION: 'Google Maps navigasjon',
    MAP_V2_ALL_PLACES: 'Alle steder',
    MAP_V2_SELECTED_GROUP: 'Valgt gruppe',
    MAP_V2_CATEGORY_SHOW_ALL: 'Vis alle',
    MAP_V2_CATEGORY_HIGHLIGHTS: 'Høydepunkter',
    MAP_V2_CATEGORY_HERITAGE: 'Kulturarv',
    MAP_V2_CATEGORY_DINING: 'Spisesteder',
    MAP_V2_CATEGORY_FUN: 'Moro',
    MAP_V2_CATEGORY_ART: 'Kunst',
    MAP_V2_CATEGORY_EVENTS: 'Arrangementer',
    MAP_V2_PLACES_POSTFIX: 'steder',
    MAP_V2_FULLSCREEN_TURN_OFF: 'Avslutt fullskjerm',
    MAP_V2_FULLSCREEN_TURN_ON: 'Gå til fullskjerm'
};
